import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Oval } from "react-loader-spinner";
import { API_URL } from "../../shared/constant";
import axios from "axios";
import { toast } from "react-toastify";
import Swal from "sweetalert2";

const Product = () => {
  const [productData, setProductData] = useState([]);
  const [showAddProduct, setShowAddProduct] = useState(true);
  const [productName, setProductName] = useState("");
  const [unitName, setUnitName] = useState("");
  const [editId, setEditId] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [loading, setLoading] = useState(true);
  const getProduct = () => {
    axios.post(API_URL.PRODUCT_LIST, { is_seller: [0, 1] }).then(
      (res) => {
        if (res.data.status === 1) {
          setProductData(res.data.data);
        }
        setLoading(false);
      },
      (error) => {
        setLoading(false);
        toast.error("Something went wrong..", {
          autoClose: 3000,
          position: "top-center",
        });
      }
    );
  };

  const deletProduct = (row) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You want to delete this - " + row.name,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        setLoading(true);
        axios.post(API_URL.PRODUCT_DELETE, { id: row.id }).then(
          (res) => {
            if (res.data.status === 1) {
              let newData = productData.filter((r) => r.id != row.id);
              setProductData(newData);
            }
            toast.success(row.name + " Delete Successfully", {
              autoClose: 3000,
              position: "top-center",
            });
            setLoading(false);
          },
          (error) => {
            setLoading(false);
            toast.error("Something went wrong..", {
              autoClose: 3000,
              position: "top-center",
            });
          }
        );
      }
    });
  };

  const saveProduct = () => {
    if (
      productName && unitName
    ) {
      setIsLoading(true);
      let payload = {
        name: productName,
        unit: unitName,
      }
      if (editId && editId > 0) {
        payload.id = editId;
      }
      const pUrl = (editId) ? API_URL.PRODUCT_UPDATE : API_URL.PRODUCT_SAVE;
      axios.post(pUrl, payload).then((res) => {
        if (res.data.status === 1) {
          if (editId) {
            setProductName('');
            setUnitName('');
            setEditId(null);
            toast.success("Updated", {
              autoClose: 3000,
              position: "top-center",
            });
          } else {
            setProductName('');
            setUnitName('');
            setEditId(null);
            toast.success("Saved", { autoClose: 3000, position: "top-center" });
          }
          getProduct();
        }
        setIsLoading(false);
      });
    }
  };

  const showProduct = (row) => {
    setEditId(row.id);
    setProductName(row.name);
    setUnitName(row.unit ? row.unit : '');
  }

  useEffect(() => {
    getProduct();
  }, []);
  return (
    <>
      <div className="page-header">
        <div className="content-page-header">
          <h5>Product ({productData.length})</h5>
          <div className="list-btn">
            <ul className="filter-list">
              <li>
                <button type="button" className="btn btn-primary" onClick={() => setShowAddProduct(true)}>
                  <i className="fa fa-plus-circle me-2" aria-hidden="true"></i>
                  Add Product
                </button>
              </li>
            </ul>
          </div>
        </div>
      </div>
      
        { showAddProduct &&
        <div className="row mb-3">
        <div className="col-sm-4">
          <input type={'text'} className='form-control'  value={productName} onChange={(e) => setProductName(e.target.value)} placeholder="Product Name" />
        </div>
        <div className="col-sm-2">
          <input type={'text'} className='form-control'  value={unitName} onChange={(e) => setUnitName(e.target.value)} placeholder="Unit" />
        </div>
        <div className="col-sm-4">
          <button type="button" disabled={(!productName || !unitName || isLoading)} className="btn btn-success" onClick={saveProduct}>
          { isLoading ? <span className="spinner-border spinner-border-sm me-2" role="status"></span> : null} Save
          </button>
          <button type="button" className="btn btn-secondary ms-2" onClick={() => setShowAddProduct(false)}>
              Cancel
          </button>
        </div> </div>}
        <div className="row">
        <div className="col-sm-12">
          <div className="card-table">
            <div className="card-body">
              {loading ? (
                <Oval
                  height={60}
                  width={60}
                  color="#7539ff"
                  wrapperStyle={{ justifyContent: "center" }}
                  wrapperClass=""
                  visible={true}
                  ariaLabel="oval-loading"
                  secondaryColor="#7539ff"
                  strokeWidth={2}
                  strokeWidthSecondary={2}
                />
              ) : (
                <div className="table-responsive">
                  <table className="table table-center table-hover datatable">
                    <thead className="thead-light">
                      <tr>
                        <th>#</th>
                        <th>Name</th>
                        <th>Unit</th>
                        <th>Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      {productData.map((row, key) => {
                        return (
                          <tr key={key}>
                            <td>{key + 1}</td>
                            <td>
                              <h2 className="table-avatar">{row.name}</h2>
                            </td>
                            <td>
                              <h2 className="table-avatar">{row.unit}</h2>
                            </td>
                            <td>
                              <button
                                onClick={() => showProduct(row)}
                                className="btn btn-sm btn-secondary me-2"
                              >
                                <i className="fa fa-edit me-1"></i> Edit
                              </button>
                              <button
                                onClick={() => deletProduct(row)}
                                className="btn btn-sm btn-danger me-2"
                              >
                                <i className="fa fa-trash me-1"></i> Delete
                              </button>
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Product;
